"use strict";
window.__meta = {
    VERSION: process.env.LAST_COMMIT,
    BUILD_MODE: process.env.BUILD_MODE,
};
